import './App.css';

function TeamPlayAnalysis() {
  return (
    <div style={{padding:50,paddingLeft:200,paddingRight:200}}>
      <h1>Welcome to my Team Play Analysis project</h1>
      <h3>This project will see updates on a weekly basis. Project start is 30/08/2026.</h3>

      I will outline here some of the main tasks to begin the project. <br/><br/>

      - A plan for Minimum Viable Product. <br/>
      - Website layout <br/>
      - camera angle of sports field <br/>
      - a tripod to hold up the mobile device for filming <br/>
      - streaming on youtube/twitch to get around storage costs? <br/>
      - sports analytics tools<br/><br/><br/><br/>


      <h3>A short description of the project.</h3> <br/>

      This project will be aimed at sports teams looking to enhance their team performance through video analysis. It will be delivered through
       a website where managers and players can use tools to interact with the raw footage by highlighting, cutting, noting, and utilising many 
       other functionalities. This will hopefully improve a team's performance, allowing the managers and players to communicate more efficiently 
       to make timely and needed improvements to the team. This project is aimed at amateur level teams. Initial testing will be based on a soccer 
       team due to having access.<br/><br/>

       Please note. The assistance of AI will be used to significantly speed up development.
    </div>
  );
}

export default TeamPlayAnalysis;